import {
  relativeTimeThreshold
} from "moment";

import {
  Trans
} from '@/plugins/Translation'
import { i18n } from './../../../plugins/i18n.js'
export default {

  getimage(img) {

    var images = require.context('../../../assets/images', false, /\.png$/)
    var url = images('./' + img + ".png");
    return images('./' + img + ".png")
  },
  getTranslatedHtml(html)
  {
    var bodyhtml=html;

    bodyhtml=bodyhtml.toString().replace('Ocak','January');
    bodyhtml=bodyhtml.toString().replace('Şubat','Feb.');
    bodyhtml=bodyhtml.toString().replace('Mart','March');
    bodyhtml=bodyhtml.toString().replace('Nisan','April');
    bodyhtml=bodyhtml.toString().replace('Mayıs','May');
    bodyhtml=bodyhtml.toString().replace('Haziran','June');
    bodyhtml=bodyhtml.toString().replace('Temmuz','September');
    bodyhtml=bodyhtml.toString().replace('Ağustos','Agust');
    bodyhtml=bodyhtml.toString().replace('Eylül','September');
    bodyhtml=bodyhtml.toString().replace('Ekim','Otober');
    bodyhtml=bodyhtml.toString().replace('Kasım','November');
    bodyhtml=bodyhtml.toString().replace('Aralık','December');

    bodyhtml=bodyhtml.toString().replace('Referanslar','References');
    bodyhtml=bodyhtml.toString().replace('Evrak Tipi','Document Type');
    bodyhtml=bodyhtml.toString().replace('Doviz Toplam','Currency Total');
    bodyhtml=bodyhtml.toString().replace('Iskonto','Discount');
    bodyhtml=bodyhtml.toString().replace('Kasa Deviri ','Safe Revolution');
    bodyhtml=bodyhtml.toString().replace('Açılış Devir','Opening Revolution');
    bodyhtml=bodyhtml.toString().replace('Devir','Revolution');
    bodyhtml=bodyhtml.toString().replace('Kalan','Balance');
    bodyhtml=bodyhtml.toString().replace('Çıkış','Outcome');
    bodyhtml=bodyhtml.toString().replace('Giriş','Income');
    bodyhtml=bodyhtml.toString().replace('Evrak No','Document No');
    bodyhtml=bodyhtml.toString().replace('Gun Sayısı ','Day Count');
    bodyhtml=bodyhtml.toString().replace('Dönem Sayısı','Period Count');
    bodyhtml=bodyhtml.toString().replace('Toplam Borç','Total Debit');
    bodyhtml=bodyhtml.toString().replace('Sıralama','Sorting');
    bodyhtml=bodyhtml.toString().replace('Vadesi Gelen Borç','Debt Due');
    bodyhtml=bodyhtml.toString().replace('Vadesi Gelen Alacak','Due Receivable');
    bodyhtml=bodyhtml.toString().replace('Masraf Merkezi Kodu','Cost Center Code'); 
    bodyhtml=bodyhtml.toString().replace('Referans','Referance'); 
    bodyhtml=bodyhtml.toString().replace('Referans ','Referance'); 
    bodyhtml=bodyhtml.toString().replace('Cari Borç','Current Debit');
    bodyhtml=bodyhtml.toString().replace('Başlangıç','Start'); 
    bodyhtml=bodyhtml.toString().replace('Başlangıç ','Start'); 
    bodyhtml=bodyhtml.toString().replace('Bitiş','End');
    bodyhtml=bodyhtml.toString().replace('Bitiş ','End');
    bodyhtml=bodyhtml.toString().replace('Cari Alacak','Current Credit');
    bodyhtml=bodyhtml.toString().replace('Toplam Borç','Total Debit');
    bodyhtml=bodyhtml.toString().replace('Toplam Alacak','Total Credit');
    bodyhtml=bodyhtml.toString().replace('Alacak Bakiye','Credit Balance');
    bodyhtml=bodyhtml.toString().replace('Borç Bakiye','Debit Balance');
    bodyhtml=bodyhtml.toString().replace('Genel Bakiye','General Balance'); 
    bodyhtml=bodyhtml.toString().replace('Cari Kodu','Account Code');
    bodyhtml=bodyhtml.toString().replace('Dönem ','Period');
    bodyhtml=bodyhtml.toString().replace('Referans (İstenilen)','Reference (Desired)');
    bodyhtml=bodyhtml.toString().replace('Masraf Merkezi ','Cost Center');
    bodyhtml=bodyhtml.toString().replace('Hesap Grubu (İstenilen)','Account Group (Desired)');
    bodyhtml=bodyhtml.toString().replace('Detay/Özet','Details/Summary');
    bodyhtml=bodyhtml.toString().replace('Program Tipi','Program Type');
    bodyhtml=bodyhtml.toString().replace('Seçenekler ','Options');
    bodyhtml=bodyhtml.toString().replace('Referans (İstenmeyen)','Reference (Unsolicited)');
    bodyhtml=bodyhtml.toString().replace('Evraklar','Documents');
    bodyhtml=bodyhtml.toString().replace('Hesap Grubu (İstenmeyen)','Account Group (Unsolicited)');
    bodyhtml=bodyhtml.toString().replace('Rapor Tipi','Report Type');
    bodyhtml=bodyhtml.toString().replace('Tüm Şirketler','All Companies');
    bodyhtml=bodyhtml.toString().replace("<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Tarih</font>","<font face = 'Tahoma' size = '1' color = '#FFFFF0'>Date</font>");
    bodyhtml=bodyhtml.toString().replace('Evrak','Document');
    bodyhtml=bodyhtml.toString().replace('Açıklama','Notes');
    bodyhtml=bodyhtml.toString().replace('Vade','Maturity');
    bodyhtml=bodyhtml.toString().replace('Referans','Reference');
    bodyhtml=bodyhtml.toString().replace('Borç','Debit'); 
    bodyhtml=bodyhtml.toString().replace('Alacak','Credit');
    bodyhtml=bodyhtml.toString().replace('Bakiye','Balance');
    bodyhtml=bodyhtml.toString().replace('Devir Toplam','Turnover Total');
    bodyhtml=bodyhtml.toString().replace('Dönem Toplam','Period Total');
    bodyhtml=bodyhtml.toString().replace('Genel Toplam','Grand Total');
    bodyhtml=bodyhtml.toString().replace('Hesap No','Account number');
    bodyhtml=bodyhtml.toString().replace('Tüm Sirketler','All Companies');
    bodyhtml=bodyhtml.toString().replace('Doviz Tipi','Currency Type');
    
    bodyhtml=bodyhtml.toString().replace('Toplam','Total')
    bodyhtml=bodyhtml.toString().replace('Toplam ','Total ');
    bodyhtml=bodyhtml.toString().replace('Adet','Count ');
    bodyhtml=bodyhtml.toString().replace('Tutar','Amount');
    bodyhtml=bodyhtml.toString().replace('Kredi Kart No','Credit Card No');
    bodyhtml=bodyhtml.toString().replace('Firma Kart No','Firm Card No');
    bodyhtml=bodyhtml.toString().replace('Firma Kart No','Firm Card No');
    bodyhtml=bodyhtml.toString().replace('GENEL TOPLAM','GRAND TOTAL');
    bodyhtml=bodyhtml.toString().replace('Havayolu Kodu','Airline Code');
    bodyhtml=bodyhtml.toString().replace('Ana Hesap','Main Account');
    bodyhtml=bodyhtml.toString().replace('Cari','Current');
    bodyhtml=bodyhtml.toString().replace('İstenilen Hesap Grubu','Desired Account Group');
    bodyhtml=bodyhtml.toString().replace('İstenmeyen Hesap Grubu','Unwanted Account Group');
    bodyhtml=bodyhtml.toString().replace('Hesap Kodu','Account Code');
    bodyhtml=bodyhtml.toString().replace('Hesap Adı','Account');
    bodyhtml=bodyhtml.toString().replace('Genel','General');
    bodyhtml=bodyhtml.toString().replace('Genel ','General ');
    bodyhtml=bodyhtml.toString().replace('Referans','Referance');
    bodyhtml=bodyhtml.toString().replace('Adı','Name');
    bodyhtml=bodyhtml.toString().replace('Adi','Name');
    bodyhtml=bodyhtml.toString().replace('Kodu','Code');
    bodyhtml=bodyhtml.toString().replace('Kodu ','Code');
    bodyhtml=bodyhtml.toString().replace('Masraf Merkezi','Cost Center ');
    bodyhtml=bodyhtml.toString().replace('Cari','Current'); 
    bodyhtml=bodyhtml.toString().replace('İstenilen Gruplar ','Desired Groups');
    bodyhtml=bodyhtml.toString().replace('İstenmeyen Gruplar ','Unwanted Groups ');
    bodyhtml=bodyhtml.toString().replace('Önceki','Before');
    bodyhtml=bodyhtml.toString().replace('İleri','Next');
    bodyhtml=bodyhtml.toString().replace('Toplam','Total');
    bodyhtml=bodyhtml.toString().replace('Tip','Type');
    bodyhtml=bodyhtml.toString().replace('Tipi','Type');
    bodyhtml=bodyhtml.toString().replace('İstenilen','Desired');
    bodyhtml=bodyhtml.toString().replace('İstenmeyen','Unwanted');
    bodyhtml=bodyhtml.toString().replace('Hepsi','All');
    bodyhtml=bodyhtml.toString().replace('Tarihe Göre','By Date');
    bodyhtml=bodyhtml.toString().replace('TL Rapor','RS Report');
    bodyhtml=bodyhtml.toString().replace('Özet Rapor','Report');
    bodyhtml=bodyhtml.toString().replace('Tümü','All');
    return bodyhtml;
  },
  getparabirimi() {
    var cred = JSON.parse(window.localStorage.getItem('credentials'))
    var birim = cred.ParaBirimi

      if (cred.ParaBirimi=="AZN" || cred.UserID==62252)
      {
        birim="AZN";
      }
     
      if (birim=="AZN")
      {
        return "₼"
      }
      if (birim=="PKR")
      {
         return 'Rs'
      }
    if (birim==null)
    {
      return '₺'
    }
    if (birim == 'TRY') {
      return '₺'
      
    } 
    else if (birim == 'TL') {
      return '₺'
    } 
    else if (birim == 'EUR') {
      return '€'
    } else if (birim == 'USD') {
      return '$'
    } 
    else if (birim == 'GBP') {
      return '£'
    } 
    else {
      return ''
    }
  },

  roundNumber(num, scale) {
    if (!("" + num).includes("e")) {
      return +(Math.round(num + "e+" + scale) + "e-" + scale);
    } else {
      var arr = ("" + num).split("e");
      var sig = ""
      if (+arr[1] + scale > 0) {
        sig = "+";
      }
      return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
  },

  getparabirimiDefault(birim) {
    if (typeof (birim) == 'undefined') {
      var cred = JSON.parse(window.localStorage.getItem('credentials'))
      if (cred.ParaBirimi!=null && cred.ParaBirimi!='undefined')
      {
        birim = cred.ParaBirimi
      }
      else
      {
        birim="TL";
      }
    }
    if (birim == 'TRY' || birim == 'TL') {
      return '₺'
    } else if (birim == 'EUR') {
      return '€'
    } else if (birim == 'USD') {
      return '$'
    } else {
      return '₺'
    }
  },

  // getSaticiTipi:[{
  //   Otel = 1,
  //       Arac = 2,
  //       Restaurant = 3,
  //       Acente = 4,
  //       RentACar = 5,
  //       Rehber = 6,
  //       Muze = 7,
  //       Charter = 8,
  //       Gemi = 9,
  //       Diger = 10,
  //       Vize = 11,
  //       TurOperatoru = 12,
  //       //Konsolosluk = 13,
  //       Sigorta = 14,
  //       Feribot = 15,
  //       Golf = 16
  // }],


  getBiletKayitTipi: [{
    Kod: 0,
    Aciklama: i18n.tc('Ticket')
  }, {
    Kod: 1,
    Aciklama: i18n.tc('Seat')
  }, {
    Kod: 2,
    Aciklama: i18n.tc('Meal')
  }, {
    Kod: 3,
    Aciklama: i18n.tc('Additional-Luggage') 
  }],

  getDovizAdi(birim) {
    if (birim == 'TRY' || birim == 'TL') {
      return 'TL'
    } else {
      return birim
    }
  },

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  },


  getDateTimeNow() {
    var tarih = this.getDateNow();

    var time = new Date();

    var saat = time.toLocaleTimeString("tr-TR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return tarih + 'T' + saat
  },


  isdateok: function (t) {

    var a = new Date(t)

    var yil = a.getFullYear()
    var ay = a.getMonth()
    var gun = a.getDay()

    if (isNaN(yil) && isNaN(ay) && isNaN(gun)) {
      return t;
    } else {
      return this.dateformat(t);
    }
  },

  adddays(days) {
    var date = new Date();
    date.setDate(date.getDate() + days);

    var today = new Date(date);

    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd

    return today

  },

  getaktifdil() {
    return Trans.getaktifdil();
  },
  getTime(a) {

    if (a != null) {

      if (a == '0001-01-01T00:00:00') {
        return null
      } else {

        if (a.length > 5) {
          var bastarih = a.split("T")
          if (bastarih[1] != '00:00:00') {

            var saat = bastarih[1].split(":")
            return saat[0] + ':' + saat[1]
          } else {
            return null
          }

        } else {
          return a
        }

      }
    } else {
      return null
    }
  },

  coperdateformat: function (t) {
    var today = new Date(t);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

     today = mm + '.' + dd + '.' + yyyy;
  },

  dateformatfor: function (t) {
    
    if (t != '0001-01-01T00:00:00' && t != '' && t != null) {
      var date = new Date(t);
      date.replace('-','.');

      return date;

    } else {
      return null
    }


  },

  dateformat: function (t) {
   
    if (t != '0001-01-01T00:00:00' && t != '' && t != null) {
      var date = new Date(t);
      var fulldate = date.toLocaleDateString("tr-TR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      return fulldate;

    } else {
      return null
    }


  },
  moneyformat: function (m) {
    if (m == null || m == '') {
      m = 0
    }
    try{
return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }catch{
return m;
    }
    
  },

  currencyformat: function (m) {
    if (m == null || m == '') {
      m = 0
    }
    return m.toFixed(4)
  },

  getYear() {
    var today = new Date();
    var yyyy = today.getFullYear();
    return yyyy
  },

  getTimeNow() {

    var time = new Date();
    var fullclock = time.toLocaleTimeString("tr-TR", {
      hour: "numeric",
      minute: "2-digit",
      //second: "2-digit",
    });
    return fullclock;

  },

  getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  getDatYear() {
    var today = new Date();
    var yyyy = today.getFullYear();
    today = yyyy + '-' + '01' + '-' + '01'
    return today
  },


  bakiyekontrol: function (m) {
    var c = parseFloat(m);
    if (c < 0) {
      var c = c * -1;
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + ' A ';
    } else if (c > 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + ' B '
    } else if (c == 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }
  },

  bakiyekontrolsimgeli: function (m) {
    var c = parseFloat(m);
    if (c < 0) {
      var c = c * -1;
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + this.getparabirimi() + ' A ';
    } else if (c > 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + this.getparabirimi() + ' B '
    } else if (c == 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + this.getparabirimi()
    }
  },



  mailkontrol: function (email) {

    var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var kont = re.test(email)
    if (kont == true) {
      return true;
    } else {
      return false;
    }
  },

  yetkilisirketlerigetir: function (sirketler) {

    var list = []
    sirketler.forEach(element => {
      if (element.UserTip == 1) {
        list.push(element)
      }
    });
    return list;
  },

  yetkisorgula(sirketkod, sirketler) {

    if (sirketkod == null) {
      var durum = false
      sirketler.forEach(element => {
        if (element.UserTip == 1) {
          durum = true
        }
      });
      return durum;
    } else {

    }

  },

  defaultKod(length) {

    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      const rnd = Math.floor(Math.random() * 90000) + 10000;
      return result + rnd;
    }
  },

  homepageAuth(page){
 var yetkiler = {
      Screen: false,
      Update: false,
      Save: false,
      Delete: false,
      Status: false,
      Message: null,
      islem: 0, // 0:bir önceki sayfaya gidecek, 1: anaşirketseçimiyapacak, 2:çıkış yapması gerekir
    }

    var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    var cred = JSON.parse(window.localStorage.getItem('credentials'));

    if (page != null) {

      let PageTitle="";
      if (page != 'login' && page != 'register'  && page != 'login-uye' && page != 'uye-detay' && page != 'uye-yeni' && page != 'login-yetkigruplist' && page != 'confirm') {

     

        if (cred != null && manage != null) {
          
          if (cred.SirketKodu != null && cred.AnaSirketKodu != null) {
            var coperCheck = page.split('-');
            
            var anasirketvarmi = false
            manage.AnaSirketInfo.forEach(element => {

              if (element.MusteriKod == cred.AnaSirketKodu) {
               
                anasirketvarmi = true
                var altsirketvarmi = false
                if (element.YetkiInfo != null) {
                  element.YetkiInfo.forEach(element1 => {

                    if(coperCheck[0] == 'coper'){

                      cred.CoperSirketler.forEach(elementCoper => {
                        if(elementCoper.SirketNo == cred.CoperSirketNo){
                          var coperCariSirketID = elementCoper.CariSirket.split('-');
                          if (element1.SirketNo == coperCariSirketID[0]) {
                            altsirketvarmi = true
                            var index = element1.SayfaYetkiInfo.map(function (e) {
                              return e.PageName;
                            }).indexOf(page);
      
                            if (index != -1) {
                              yetkiler.Status = true
                              yetkiler.Screen = element1.SayfaYetkiInfo[index].Screen
                              yetkiler.Save = element1.SayfaYetkiInfo[index].Save
                              yetkiler.Update = element1.SayfaYetkiInfo[index].Update
                              yetkiler.Delete = element1.SayfaYetkiInfo[index].Delete
                              PageTitle=element1.SayfaYetkiInfo[index].PageTitle;
      
      
                              if (element1.SayfaYetkiInfo[index].Screen == false) {
                                yetkiler.Status = false
                                yetkiler.islem = 0
                                yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                              }
                            } else {
                              yetkiler.Status = false
                              this.islem = 0
                              yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                              yetkiler.Screen = false
                              yetkiler.Save = false
                              yetkiler.Update = false
                              yetkiler.Delete = false
                            }
      
                          }
                        }
                      });
                    }else if (element1.SirketNo == cred.SirketKodu) {
                      altsirketvarmi = true
                      var index = element1.SayfaYetkiInfo.map(function (e) {
                        return e.PageName;
                      }).indexOf(page);

                      if (index != -1) {
                        yetkiler.Status = true
                        yetkiler.Screen = element1.SayfaYetkiInfo[index].Screen
                        yetkiler.Save = element1.SayfaYetkiInfo[index].Save
                        yetkiler.Update = element1.SayfaYetkiInfo[index].Update
                        yetkiler.Delete = element1.SayfaYetkiInfo[index].Delete
                        PageTitle=element1.SayfaYetkiInfo[index].PageTitle;

                        if (element1.SayfaYetkiInfo[index].Screen == false) {
                          yetkiler.Status = false
                          yetkiler.islem = 0
                          
                          yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                          
                        }
                      } else {
                        yetkiler.Status = false
                        this.islem = 0
                        yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                        yetkiler.Screen = false
                        yetkiler.Save = false
                        yetkiler.Update = false
                        yetkiler.Delete = false
                      }

                    }

                    if (altsirketvarmi != true) {
                      yetkiler.Status = false;
                      yetkiler.Screen = false
                      yetkiler.Save = false
                      yetkiler.Update = false
                      yetkiler.Delete = false
                      yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                      this.islem = 0
                    }
                  });
                } else {
                  // this.$t('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                  window.alert('Bu şirket için yetkileriniz tanımlanmamış, lütfen admin kullanıcınızdan yetki talep ediniz.')
                }
              }

              if (anasirketvarmi != true) {
                yetkiler.Status = false;
                yetkiler.Screen = false
                yetkiler.Save = false
                yetkiler.Update = false
                yetkiler.Delete = false
                yetkiler.Message = 'Ana şirket bilgilerine ulaşılamadı, lütfen ana şirket seçimi yapınız.'
                yetkiler.islem = 1
              }
            });
          } else {
            yetkiler.Status = false;
            yetkiler.Screen = false
            yetkiler.Save = false
            yetkiler.Update = false
            yetkiler.Delete = false
            yetkiler.Message = 'Şirket bilgilerine ulaşılamadı, lütfen şirket seçimi yapınız.'
            yetkiler.islem = 1
          }

        } else {
          yetkiler.Status = false;
          yetkiler.Screen = false
          yetkiler.Save = false
          yetkiler.Update = false
          yetkiler.Delete = false
          yetkiler.Message = 'Yetki ile ilgili gerekli bilgilere ulaşılamadı, lütfen giriş çıkış yapınız.'
          yetkiler.islem = 2
        }
      } else {
        yetkiler.Screen = true
        yetkiler.Save = true
        yetkiler.Update = true
        yetkiler.Delete = true
      }
      yetkiler.Message +=' "'+page+ ' : '+PageTitle +'"'
    } else {
      yetkiler.Status = false;
      yetkiler.Screen = false
      yetkiler.Save = false
      yetkiler.Update = false
      yetkiler.Delete = false
      yetkiler.islem = 0
      yetkiler.Message = 'Sayfa bilgilerine ulaşılamadı, lütfen sayfaya yeniden giriş yapınız..'
    }

    // console.log(' Görüntüle: ' + yetkiler.Screen)

    // console.log('Kaydet: ' + yetkiler.Save)


    // console.log('Update: ' + yetkiler.Update)


    // console.log('Sil: ' + yetkiler.Delete)


    // console.log('Status: ' + yetkiler.Status)


    // console.log('islem: ' + yetkiler.islem)


    // console.log('mesaj: ' + yetkiler.Message)

    
    return yetkiler
  },
  pageScreenAuth(page) {
    
    var yetkiler = {
      Screen: false,
      Update: false,
      Save: false,
      Delete: false,
      Status: false,
      Message: null,
      islem: 0, // 0:bir önceki sayfaya gidecek, 1: anaşirketseçimiyapacak, 2:çıkış yapması gerekir
    }

    var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    var cred = JSON.parse(window.localStorage.getItem('credentials'));

    if (page != null) {

      let PageTitle="";
      if (page != 'login' && page != 'register' && page != 'anasirket' && page != 'login-uye' && page != 'uye-detay' && page != 'uye-yeni' && page != 'login-yetkigruplist' && page != 'confirm') {

     

        if (cred != null && manage != null) {
          
          if (cred.SirketKodu != null && cred.AnaSirketKodu != null) {
            var coperCheck = page.split('-');
            
            var anasirketvarmi = false
            manage.AnaSirketInfo.forEach(element => {

              if (element.MusteriKod == cred.AnaSirketKodu) {
               
                anasirketvarmi = true
                var altsirketvarmi = false
                if (element.YetkiInfo != null) {
                  element.YetkiInfo.forEach(element1 => {

                    if(coperCheck[0] == 'coper'){

                      cred.CoperSirketler.forEach(elementCoper => {
                        if(elementCoper.SirketNo == cred.CoperSirketNo){
                          var coperCariSirketID = elementCoper.CariSirket.split('-');
                          if (element1.SirketNo == coperCariSirketID[0]) {
                            altsirketvarmi = true
                            var index = element1.SayfaYetkiInfo.map(function (e) {
                              return e.PageName;
                            }).indexOf(page);
      
                            if (index != -1) {
                              yetkiler.Status = true
                              yetkiler.Screen = element1.SayfaYetkiInfo[index].Screen
                              yetkiler.Save = element1.SayfaYetkiInfo[index].Save
                              yetkiler.Update = element1.SayfaYetkiInfo[index].Update
                              yetkiler.Delete = element1.SayfaYetkiInfo[index].Delete
                              PageTitle=element1.SayfaYetkiInfo[index].PageTitle;
      
      
                              if (element1.SayfaYetkiInfo[index].Screen == false) {
                                yetkiler.Status = false
                                yetkiler.islem = 0
                                yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                              }
                            } else {
                              yetkiler.Status = false
                              this.islem = 0
                              yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                              yetkiler.Screen = false
                              yetkiler.Save = false
                              yetkiler.Update = false
                              yetkiler.Delete = false
                            }
      
                          }
                        }
                      });
                    }else if (element1.SirketNo == cred.SirketKodu) {
                      altsirketvarmi = true
                      var index = element1.SayfaYetkiInfo.map(function (e) {
                        return e.PageName;
                      }).indexOf(page);

                      if (index != -1) {
                        yetkiler.Status = true
                        yetkiler.Screen = element1.SayfaYetkiInfo[index].Screen
                        yetkiler.Save = element1.SayfaYetkiInfo[index].Save
                        yetkiler.Update = element1.SayfaYetkiInfo[index].Update
                        yetkiler.Delete = element1.SayfaYetkiInfo[index].Delete
                        PageTitle=element1.SayfaYetkiInfo[index].PageTitle;

                        if (element1.SayfaYetkiInfo[index].Screen == false) {
                          yetkiler.Status = false
                          yetkiler.islem = 0
                          
                          yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                          
                        }
                      } else {
                        yetkiler.Status = false
                        this.islem = 0
                        yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                        yetkiler.Screen = false
                        yetkiler.Save = false
                        yetkiler.Update = false
                        yetkiler.Delete = false
                      }

                    }

                    if (altsirketvarmi != true) {
                      yetkiler.Status = false;
                      yetkiler.Screen = false
                      yetkiler.Save = false
                      yetkiler.Update = false
                      yetkiler.Delete = false
                      yetkiler.Message = i18n.tc('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                      this.islem = 0
                    }
                  });
                } else {
                  // this.$t('You-do-not-have-permission-to-view-this-page-please-request-permission-from-your-admin-user.')
                  window.alert('Bu şirket için yetkileriniz tanımlanmamış, lütfen admin kullanıcınızdan yetki talep ediniz.')
                }
              }

              if (anasirketvarmi != true) {
                yetkiler.Status = false;
                yetkiler.Screen = false
                yetkiler.Save = false
                yetkiler.Update = false
                yetkiler.Delete = false
                yetkiler.Message = 'Ana şirket bilgilerine ulaşılamadı, lütfen ana şirket seçimi yapınız.'
                yetkiler.islem = 1
              }
            });
          } else {
            yetkiler.Status = false;
            yetkiler.Screen = false
            yetkiler.Save = false
            yetkiler.Update = false
            yetkiler.Delete = false
            yetkiler.Message = 'Şirket bilgilerine ulaşılamadı, lütfen şirket seçimi yapınız.'
            yetkiler.islem = 1
          }

        } else {
          yetkiler.Status = false;
          yetkiler.Screen = false
          yetkiler.Save = false
          yetkiler.Update = false
          yetkiler.Delete = false
          yetkiler.Message = 'Yetki ile ilgili gerekli bilgilere ulaşılamadı, lütfen giriş çıkış yapınız.'
          yetkiler.islem = 2
        }
      } else {
        yetkiler.Screen = true
        yetkiler.Save = true
        yetkiler.Update = true
        yetkiler.Delete = true
      }
      yetkiler.Message +=' "'+page+ ' : '+PageTitle +'"'
    } else {
      yetkiler.Status = false;
      yetkiler.Screen = false
      yetkiler.Save = false
      yetkiler.Update = false
      yetkiler.Delete = false
      yetkiler.islem = 0
      yetkiler.Message = 'Sayfa bilgilerine ulaşılamadı, lütfen sayfaya yeniden giriş yapınız..'
    }

    // console.log(' Görüntüle: ' + yetkiler.Screen)

    // console.log('Kaydet: ' + yetkiler.Save)


    // console.log('Update: ' + yetkiler.Update)


    // console.log('Sil: ' + yetkiler.Delete)


    // console.log('Status: ' + yetkiler.Status)


    // console.log('islem: ' + yetkiler.islem)


    // console.log('mesaj: ' + yetkiler.Message)

    
    return yetkiler
  },

  turkceUpperCase(word) {
    return word.toLocaleUpperCase('TR');
  }

}